<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<script>
import appConfig from '@src/app.config'
import { EventBus } from '@/src/utils/event-bus';

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      const url = window.location.href
      if(url.includes(process.env.VUE_APP_HEAVEN_BASE_URL)) {
        return title ? `${title} | Heaven Erp` : 'Heaven Erp'
      } else {
        return title ? `${title} | ${appConfig.title}` : appConfig.title
      }
      
    },
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    }
  },
  created() {
    EventBus.$on("errorNotify", (data) => {
      this.$bvToast.toast(data, {
        title: "Aviso",
        variant: "danger",
        autoHideDelay: 5000,
        appendToast: true,
      });
    });

    // Validar Domínio Greenn/Heaven
    const url = window.location.href
    if(url.includes(process.env.VUE_APP_HEAVEN_BASE_URL)) {
      this.$store.dispatch('updateIsHeaven', true)
    } else {
      this.$store.dispatch('updateIsHeaven', false)
    }
  },
  beforeDestroy() {
    EventBus.$off("errorNotify");
  }
}
</script>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Design variables and utilities from src/design.
@import '@design';
.dropdown-item.disabled,
.dropdown-item:disabled {
  background: #f7f7f7 !important;
  opacity: 0.5 !important;
}

.externclass {
  display: flex;
  align-items: center;
  gap: 5px;
  box-sizing: border-box;
  flex-wrap: nowrap;
  position: relative;
}

.externclass p {
  margin: 0 !important;
}

.classification {
  width: 6px;
  height: 6px;
  border-radius: 100%;
  box-sizing: border-box;
  flex-wrap: nowrap;
}
.classification.saque{
  position: absolute;
    left: -10px;
}

.btn.dropdown-toggle.btn-secondary, .btn.dropdown-toggle.btn-secondary:focus  {
  background: transparent !important;
  border: none !important;
  outline: none !important;
}

.progress-bar.success-custom {
  background-color: #04D43F !important;
  border-radius: 10px !important;
  margin-right: 2px;
}

.progress-bar.warning-custom {
  background-color: #FFD014 !important;
  border-radius: 10px !important;
  margin-right: 2px;
}

.progress-bar.danger-custom {
  background-color: #F41A42 !important;
  border-radius: 10px !important;
}

.fix-not-center .daterangepicker.openscenter{
  left: -60px !important;
}

</style>